import React from 'react';
import { useTranslation } from 'react-i18next';

const roleTranslations = {
  "ადმინისტრატორი": {
    en: 'Administrator',
    ru: 'Администратор',
    ka: 'ადმინისტრატორი',
  },
  "ბუღალტერი": {
    en: 'Accountant',
    ru: 'Бухгалтер',
    ka: 'ბუღალტერი',
  },
  "დილერი": {
    en: 'Dealer',
    ru: 'Дилер',
    ka: 'დილერი',
  },
  "დილერის კლიენტი": {
    en: 'Dealer client',
    ru: 'Клиент дилера',
    ka: 'დილერის კლიენტი',
  },
  "კლიენტი": {
    en: 'Client',
    ru: 'Клиент',
    ka: 'კლიენტი',
  },
  "მარკეტინგის ხელმძღვანელი": {
    en: 'Marketing manager',
    ru: 'Руководитель маркетинга',
    ka: 'მარკეტინგის ხელმძღვანელი',
  },
  "მთავარი ბუღალტერი": {
    en: 'Chief accountant',
    ru: 'Главный бухгалтер',
    ka: 'მთავარი ბუღალტერი',
  },
  "ოპერატორი": {
    en: 'Operator',
    ru: 'Оператор',
    ka: 'ოპერატორი',
  },
  "სეილების უფროსი": {
    en: 'Sales head',
    ru: 'Глава отдела продаж',
    ka: 'სეილების უფროსი',
  },
  "სეილერი": {
    en: 'Seller',
    ru: 'продавец',
    ka: 'სეილერი',
  },
  "სუპერ-ადმინ": {
    en: 'Superadmin',
    ru: 'Суперадмин',
    ka: 'სუპერ-ადმინ',
  },
  "უმცროსი ადმინისტრატორი": {
    en: 'Junior administrator',
    ru: 'Младший администратор',
    ka: 'უმცროსი ადმინისტრატორი',
  },
  "უფროსი ბუღალტერი": {
    en: 'Senior accountant',
    ru: 'Старший бухгалтер',
    ka: 'უფროსი ბუღალტერი',
  },
  "ფოთი ხელმძღვანელი": {
    en: 'Poti branch manager',
    ru: 'Менеджер филиала в Поти',
    ka: 'ფოთი ხელმძღვანელი',
  },
  "ფოთის ოპერატორი": {
    en: 'Poti operator',
    ru: 'Оператор в Поти',
    ka: 'ფოთის ოპერატორი',
  },


  "ადმინი": {
    en: 'Admin',
    ru: 'Админ',
    ka: 'ადმინი',
  },
  "გამწვანების ოპერატორი": {
    en: 'Greening operator',
    ru: 'Оператор озеленения',
    ka: 'გამწვანების ოპერატორი',
  },
  "ლოჯისტიკა": {
    en: 'Logistics',
    ru: 'Логистика',
    ka: 'ლოჯისტიკა',
  },
  "სტატუსის გარეშე": {
    en: 'No status',
    ru: 'Без статуса',
    ka: 'სტატუსის გარეშე',
  },
  "ფოთის ხელმძღვანელი": {
    en: 'Poti branch manager',
    ru: 'Менеджер филиала в Поти',
    ka: 'ფოთის ხელმძღვანელი',
  },
};






const RoleLanguage = ({ role }) => {
  const { i18n } = useTranslation();
  const lang = i18n.language;          // 'en' | 'ru' | 'ka' | etc.
  const entry = roleTranslations[role];

  if (!entry) return role;            // unknown role → render nothing

  // if translation for current language doesn't exist, fall back to Georgian
  const translated = entry[lang] ?? entry.ka;
  return <>{translated}</>;
};

export default RoleLanguage;
